import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, IconButton, Paper } from "@mui/material";
import ClaimTabs from "../../claims/common/ClaimTabs";
import activeDeceased from "../../../../assets/images/activeDeceased.svg"
import inactiveDeceased from "../../../../assets/images/inactiveDeceased.svg";
import inactiveCateringDetails from "../../../../assets/images/inactiveCateringDetails.svg";
import inactiveLogistic from "../../../../assets/images/inactiveLogistic.svg";
import activeCateringDetails from "../../../../assets/images/activeCateringDetails.svg";
import activeLogistic from "../../../../assets/images/activeLogistic.svg";
import ClaimantAndDeceased from "./calimantAndDeceased/ClaimantAndDeceased";
import CateringSetup from "./cateringSetuo/CateringSetup";
import Logistics from "./logistics/Logistics";
import { BorderColorOutlined as BorderColorOutlinedIcon } from "../../../../components/icons";
import {
  OperationsPageShell,
  operationsActionBarSx,
  operationsDetailPaperSx,
} from "../../ifas/components/OperationsUI";
import { useCateringStore } from "../../../../store/useCateringStore";

export default function CateringDetails(props: any) {
  const {
    viewMode,
    onComplete,
    onConfirm,
    isSaving,
    isConfirming,
    onHistoryClick,
  } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const { selectedCatering, setSelectedCatering } = useCateringStore();
  const snapshotRef = useRef<any>(null);
  
  const vehiclePortalTabs = [
    {
      id: 0,
      icon: { active: activeDeceased, inactive: inactiveDeceased },
      alt: " Claimant And Deceased Details",
    },
     {
      id: 1,
      icon: { active: activeCateringDetails, inactive: inactiveCateringDetails },
      alt: " Catering Setup",
    },
    {
      id: 2,
      icon: { active: activeLogistic, inactive: inactiveLogistic },
      alt: " Logistics & Equipment",
    },
  ];


  const renderTitle = () => {
    return tabData[activeTab]?.alt || "";
  };

  const tabData = vehiclePortalTabs

  const renderTabContent = () => {
      switch (activeTab) {
        case 0:
          return <ClaimantAndDeceased isEditable={isEditing} />;
        case 1:
          return <CateringSetup isEditable={isEditing} />;
        case 2:
          return <Logistics isEditable={isEditing} />;
      }
    }

  useEffect(() => {
    setActiveTab(0);
    setIsEditing(false);
    snapshotRef.current = null;
  }, [viewMode]);

  const canEdit = useMemo(
    () => Boolean(selectedCatering?.cateringId),
    [selectedCatering?.cateringId],
  );

  const handleStartEdit = () => {
    if (!canEdit || !selectedCatering) return;
    snapshotRef.current = JSON.parse(JSON.stringify(selectedCatering));
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    const snapshot = snapshotRef.current;
    if (snapshot) {
      setSelectedCatering(snapshot);
    }
    snapshotRef.current = null;
    setIsEditing(false);
  };

  const handleUpdate = async () => {
    await onComplete?.();
    snapshotRef.current = null;
    setIsEditing(false);
  };

  return (
    <OperationsPageShell
      eyebrow="Catering Details"
      title={renderTitle().trim()}
      description="Review claimant information, catering setup, logistics, and equipment requirements for the selected catering request."
      actions={
        <Box sx={operationsActionBarSx}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onHistoryClick}
          >
            History
          </Button>
          {!isEditing && (
            <IconButton onClick={handleStartEdit} disabled={!canEdit}>
              <BorderColorOutlinedIcon
                sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
              />
            </IconButton>
          )}
          {isEditing && (
            <>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCancelEdit}
                disabled={isSaving || isConfirming}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleUpdate}
                disabled={isSaving || isConfirming}
              >
                {isSaving ? "Updating..." : "Update"}
              </Button>
            </>
          )}
          <Button
            variant="contained"
            color="secondary"
            onClick={onConfirm}
            disabled={isSaving || isConfirming}
          >
            {isConfirming ? "Confirming..." : "Confirm Job"}
          </Button>
        </Box>
      }
    >
        {/* <Box display="flex" gap={2} flexWrap={{ xs: "wrap", md: "nowrap" }}>
          {showDropdown &&
            ((role === "consultant" && claimStatus === "DRAFT") ||
              (role === "claim_administrator" && claimStatus === "VETTED") ||
              (role === "claim_manager" && claimStatus === "NEW") ||
              (role === "finance" && claimStatus === "APPROVED") ||
              (role === "underwriter" && claimStatus === "REVIEWED")) && (
              <CustomDropdown
                value={value}
                onChange={handleDropdownChange}
                options={dropdownOptions}
                placeholder="Select Option"
              />
            )}
          {((role === "consultant" && claimStatus === "DRAFT") ||
            (role === "claim_administrator" && claimStatus === "VETTED") ||
            (role === "claim_manager" && claimStatus === "NEW") ||
            (role === "underwriter" && claimStatus === "REVIEWED") ||
            (role === "finance" && claimStatus === "APPROVED")) &&
            isClosable && (
              <ButtonComp
                variant="contained"
                height={40}
                width={150}
                textTransform="none"
                color="secondary"
                onClick={() => setShowCloseClaimPopup(true)}
              >
                Close Claim
              </ButtonComp>
            )}

          {role === "underwriter" && isAssignedToMe && (
            <>
              <ButtonUnderwriter
                onClick={() => setShowClaimApprove(true)}
                icon={checkIcon}
                label="Approve"
                color="#20BF55"
              />
              <ButtonUnderwriter
                onClick={() => setShowRejectDialogue(true)}
                icon={rejectIcon}
                label="Decline"
                color="#E8003F"
              />
            </>
          )}

          {isMobile ? (
            <Tooltip title="History">
              <ButtonComp
                variant="contained"
                height={40}
                width={40}
                color="secondary"
                onClick={onHistoryClick}
              >
                <HistoryIcon />
              </ButtonComp>
            </Tooltip>
          ) : (
            <ButtonComp
              variant="contained"
              height={40}
              width={120}
              textTransform="none"
              color="secondary"
              onClick={onHistoryClick}
            >
              History
            </ButtonComp>
          )}

          {role !== "underwriter" &&
            claimStatus !== "CLOSED" &&
            (showSubmitButton || showSubmit) && (
              <ButtonComp
                variant="outlined"
                height={40}
                width={190}
                textTransform="none"
                onClick={() => {
                  if (isEditable && role === "consultant") {
                    handleUpdate?.();
                  } else {
                    if (role === "claim_manager") {
                      if (isDeathClaim) {
                        setShowManagerSubmitPopup(true);
                      } else if (isChecked) {
                        setShowManagerSubmitPopup(true);
                      } else
                        showInfoToast("Please verify details in legacy system");
                    } else if (role === "finance") {
                      setShowFinanceSubmitPopup(true);
                    } else if (role === "claim_administrator") {
                      onHandleSumbit("admin_submit");
                    } else if (role === "consultant") {
                      if (!isBankingVerified) {
                        showInfoToast("Please verify bank information");
                      } else onHandleSumbit("consultant_submit");
                    } else {
                      onHandleSumbit("consultant_submit");
                    }
                  }
                }}
              >
                {isEditable && role === "consultant" ? "Update" : "Submit"}
              </ButtonComp>
            )}

          {role === "consultant" &&
            claimStatus === "DRAFT" &&
            (assignmentDetails === user_name ||
              isAssignedMeOrSomeone ||
              showSubmitButton) && (
              <BorderColorIcon
                sx={{ cursor: "pointer", color: "black", fontSize: "2rem" }}
                onClick={onEditClick}
              />
            )}
        </Box> */}
      {/* Card Container */}
      <Paper
        sx={operationsDetailPaperSx}
        elevation={0}
      >
        {/* Icons Header */}
        <ClaimTabs
          tabs={tabData}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
        {/* Section Title */}
        <Box mt={3}>
          {/* <Box display="flex" flexDirection="row" gap={3}></Box> */}
        {/* Input Grid */}
        {renderTabContent()}
        </Box>
      </Paper>
    </OperationsPageShell>
  );
}
